interface IconProps {
  size?: number
  className?: string
}

/**
 * Linear-style priority indicator (High).
 * Three ascending bars — all filled.
 * Color is inherited from the parent via `currentColor`, so apply a text-color
 * class to control it.
 */
const IconPriorityHigh = (props: IconProps) => {
  return (
    <svg
      width={props.size ?? 16}
      height={props.size ?? 16}
      viewBox="0 0 16 16"
      fill="currentColor"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="1.5" y="8" width="3" height="6" rx="1" />
      <rect x="6.5" y="5" width="3" height="9" rx="1" />
      <rect x="11.5" y="2" width="3" height="12" rx="1" />
    </svg>
  )
}

export default IconPriorityHigh
